import React, { FC, useMemo, useRef, useState } from 'react';

import { Column, FilterRow, Pager, Paging } from 'devextreme-react/data-grid';

import { AppCard, AppLayoutTop } from 'components/appComponents';
import ClaimsProvider from 'components/claimsBlock';
import { MONEY_FORMAT } from 'constants/formats';
import { Button, DataGrid } from 'devextreme-react';
import $createStore from 'utils/create-store-instance';

import { CreateEditModal, DeleteModal } from './components';

type Props = {
  adjustmentId: number | string;
  refreshDetail: () => void;
};

const BlockAdjustmentTable: FC<Props> = ({ adjustmentId, refreshDetail }) => {
  const [openId, setOpenId] = useState<number | null>(null);
  const [visibleDeleteModal, setVisibleDeleteModal] = useState(false);
  const [visibleModal, setVisibleModal] = useState(false);

  const requestDateSource = useMemo(() => {
    return $createStore(`/v1/DriverTonarAdjustments/${adjustmentId}/details`, 'id');
  }, [adjustmentId]);

  const refGrid = useRef<DataGrid | null>(null);

  const refresh = () => {
    refGrid.current?.instance.refresh();
    refreshDetail();
  };

  return (
    <div>
      <AppLayoutTop title="Детализация">
        <ClaimsProvider claimsBlock={['CanCreateTonarAdjustmentsDetails']}>
          <Button
            width={120}
            text="Создать"
            type="default"
            onClick={() => {
              setOpenId(null);
              setVisibleModal(true);
            }}
          />
        </ClaimsProvider>
      </AppLayoutTop>
      <CreateEditModal
        changeVisible={setVisibleModal}
        id={openId}
        adjustmentId={+adjustmentId}
        refresh={refresh}
        visible={visibleModal}
      />
      <DeleteModal changeVisible={setVisibleDeleteModal} id={openId} refresh={refresh} visible={visibleDeleteModal} />
      <AppCard>
        <DataGrid
          dataSource={requestDateSource as any}
          showBorders={false}
          loadPanel={{
            enabled: true,
            text: 'Загрузка',
          }}
          ref={refGrid}
          remoteOperations={true}
        >
          <FilterRow visible={true} />
          <Column dataField="id" caption="Номер" width={80} />
          <Column dataField="description" caption="Описание" />
          <Column dataField="sum" caption="Сумма руб." width={140} format={MONEY_FORMAT} />
          <Column dataField="comment" caption="Комментарий" />
          <Column
            dataField=""
            caption=""
            width={120}
            cellRender={({ data }) => (
              <>
                <ClaimsProvider claimsBlock={['CanEditTonarAdjustmentsDetails']}>
                  <Button
                    icon="edit"
                    type="default"
                    stylingMode="text"
                    onClick={() => {
                      setOpenId(data.id);
                      setVisibleModal(true);
                    }}
                  />
                </ClaimsProvider>
                <ClaimsProvider claimsBlock={['CanDeleteTonarAdjustmentsDetails']}>
                  <Button
                    icon="trash"
                    type="default"
                    stylingMode="text"
                    onClick={() => {
                      setVisibleDeleteModal(true);
                      setOpenId(data.id);
                    }}
                  />
                </ClaimsProvider>
              </>
            )}
          />

          <Paging defaultPageSize={15} />
          <Pager showPageSizeSelector={true} allowedPageSizes={[15, 30, 50, 100]} />
        </DataGrid>
      </AppCard>
    </div>
  );
};

export default BlockAdjustmentTable;
